import Vue from 'vue'
import Element from 'element-ui'
import '@/sass/element-variables.scss'

Vue.use(Element)
